export const mapStyleJson = [{
    "featureType": "land",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#eaeef1"
    }
}, {
    "featureType": "land",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#d0d7da"
    }
}, {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#c2dff1"
    }
}, {
    "featureType": "green",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#eaeef1"
    }
}, {
    "featureType": "manmade",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#eaeef1"
    }
}, {
    "featureType": "building",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#eaeef1"
    }
}, {
    "featureType": "highway",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#ffffff"
    }
}, {
    "featureType": "highway",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#d0d7da"
    }
}, {
    "featureType": "arterial",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#ffffff"
    }
}, {
    "featureType": "arterial",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#d0d7da"
    }
}, {
    "featureType": "building",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#d0d7da"
    }
}, {
    "featureType": "manmade",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#d0d7da"
    }
}, {
    "featureType": "green",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#d0d7da"
    }
}, {
    "featureType": "local",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#ffffff"
    }
}, {
    "featureType": "local",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#d0d7da"
    }
}, {
    "featureType": "railway",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#ffffff"
    }
}, {
    "featureType": "railway",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#d0d7da"
    }
}, {
    "featureType": "subway",
    "elementType": "geometry.fill",
    "stylers": {
        "weight": "0.8"
    }
}, {
    "featureType": "subway",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#eaeef1"
    }
}, {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": {
        "color": "#6f7a81"
    }
}, {
    "featureType": "poi",
    "elementType": "labels.icon",
    "stylers": {
        "lightness": -28,
        "saturation": -100,
        "visibility": "off"
    }
}, {
    "featureType": "poi",
    "elementType": "labels.text.stroke",
    "stylers": {
        "color": "#ffffff"
    }
}, {
    "featureType": "boundary",
    "elementType": "geometry.fill",
    "stylers": {
        "color": "#bbc6ca"
    }
}, {
    "featureType": "subway",
    "elementType": "labels.icon",
    "stylers": {
        "color": "#d0d7da",
        "visibility": "on"
    }
}, {
    "featureType": "boundary",
    "elementType": "geometry.stroke",
    "stylers": {
        "color": "#ffffff",
        "visibility": "on"
    }
}, {
    "featureType": "subway",
    "elementType": "labels.text.fill",
    "stylers": {
        "color": "#6f7a81",
        "visibility": "on"
    }
}, {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": {
        "color": "#6f7a81"
    }
}, {
    "featureType": "arterial",
    "elementType": "labels.text.fill",
    "stylers": {
        "color": "#6f7a81"
    }
}, {
    "featureType": "arterial",
    "elementType": "labels.text.stroke",
    "stylers": {
        "color": "#ffffff"
    }
}, {
    "featureType": "highway",
    "elementType": "labels.text.fill",
    "stylers": {
        "color": "#6f7a81"
    }
}, {
    "featureType": "highway",
    "elementType": "labels.text.stroke",
    "stylers": {
        "color": "#ffffff"
    }
}, {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": {
        "color": "#6f7a81"
    }
}, {
    "featureType": "label",
    "elementType": "labels.icon",
    "stylers": {
        "color": "#ffffff"
    }
}, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": {
        "visibility": "on"
    }
}];
export const BlueMapStyle = [{
        'featureType': 'water',
        'elementType': 'all',
        'stylers': {
            'color': '#4c5777'
        }
    },
    {
        'featureType': 'land',
        'elementType': 'all',
        'stylers': {
            'color': '#172137'
        }
    },
    {
        'featureType': 'green',
        'elementType': 'all',
        'stylers': {
            'color': '#282f57'
        }
    },
    {
        'featureType': 'manmade',
        'elementType': 'all',
        'stylers': {
            'color': '#3f4b8c'
        }
    },
    {
        'featureType': 'building',
        'elementType': 'all',
        'stylers': {
            'color': '#3f4b8c'
        }
    },
    {
        'featureType': 'boundary',
        'elementType': 'geometry',
        'stylers': {
            'color': '#4f6b9e'
        }
    },
    {
        'featureType': 'railway',
        'elementType': 'geometry',
        'stylers': {
            'color': '#4f6b9e'
        }
    },
    {
        'featureType': 'highway',
        'elementType': 'geometry.stroke',
        'stylers': {
            'color': '#202749',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'arterial',
        'elementType': 'geometry.fill',
        'stylers': {
            'color': '#4f6b9e',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'local',
        'elementType': 'geometry.fill',
        'stylers': {
            'color': '#303a6d'
        }
    },
    {
        'featureType': 'local',
        'elementType': 'geometry.stroke',
        'stylers': {
            'color': '#2d3667',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'subway',
        'elementType': 'all',
        'stylers': {
            'color': '#445195',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'all',
        'elementType': 'labels.text.stroke',
        'stylers': {
            'color': '#141831'
        }
    },
    {
        'featureType': 'all',
        'elementType': 'labels.text.fill',
        'stylers': {
            'color': '#5564b2'
        }
    },
    {
        'featureType': 'poi',
        'elementType': 'all',
        'stylers': {
            'color': '#141831',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'subway',
        'elementType': 'all',
        'stylers': {
            'visibility': 'off'
        }
    },
    {
        'featureType': 'arterial',
        'elementType': 'geometry.stroke',
        'stylers': {
            'color': '#181e3e'
        }
    },
    {
        'featureType': 'highway',
        'elementType': 'geometry',
        'stylers': {
            'color': '#324160',
            'weight': '0.9'
        }
    },
    {
        'featureType': 'highway',
        'elementType': 'labels',
        'stylers': {
            'color': '#172137',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'label',
        'elementType': 'labels',
        'stylers': {
            'visibility': 'off'
        }
    },
    {
        'featureType': 'administrative',
        'elementType': 'geometry',
        'stylers': {}
    }
];

export const Blueness = [{
        "featureType": "background",
        "elementType": "all",
        "stylers": {
            "color": "#141b34",
            "weight": "0.1",
            "lightness": -19,
            "saturation": -10
        }
    },
    {
        "featureType": "boundary",
        "elementType": "all",
        "stylers": {
            "color": "#18213f"
        }
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": {
            "color": "#3d85c6"
        }
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": {
            "visibility": "off"
        }
    },
    {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
            "color": "#62687c",
            "visibility": "off"
        }
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.stroke",
        "stylers": {
            "color": "#18213f"
        }
    },
    {
        "featureType": "boundary",
        "elementType": "labels.text.fill",
        "stylers": {
            "color": "#839dd3"
        }
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": {
            "color": "#1e2d59"
        }
    },
    {
        "featureType": "local",
        "elementType": "labels.text.fill",
        "stylers": {}
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": {
            "color": "#839dd3"
        }
    },
    {
        "featureType": "boundary",
        "elementType": "geometry.fill",
        "stylers": {
            "color": "#20438cff"
        }
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": {
            "color": "#4c5777"
        }
    }
];


export const BluenessNoLabel = [{
        'featureType': 'water',
        'elementType': 'all',
        'stylers': {
            'color': '#566382'
        }
    },
    {
        'featureType': 'land',
        'elementType': 'all',
        'stylers': {
            'color': '#172137'
        }
    },
    {
        'featureType': 'green',
        'elementType': 'all',
        'stylers': {
            'color': '#282f57'
        }
    },
    {
        'featureType': 'manmade',
        'elementType': 'all',
        'stylers': {
            'color': '#3f4b8c'
        }
    },
    {
        'featureType': 'building',
        'elementType': 'all',
        'stylers': {
            'color': '#3f4b8c'
        }
    },
    {
        'featureType': 'boundary',
        'elementType': 'geometry',
        'stylers': {
            'color': '#4f6b9e'
        }
    },
    {
        'featureType': 'railway',
        'elementType': 'geometry',
        'stylers': {
            'color': '#4f6b9e'
        }
    },
    {
        'featureType': 'highway',
        'elementType': 'geometry.stroke',
        'stylers': {
            'color': '#202749',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'arterial',
        'elementType': 'geometry.fill',
        'stylers': {
            'color': '#4f6b9e',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'local',
        'elementType': 'geometry.fill',
        'stylers': {
            'color': '#303a6d'
        }
    },
    {
        'featureType': 'local',
        'elementType': 'geometry.stroke',
        'stylers': {
            'color': '#2d3667',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'subway',
        'elementType': 'all',
        'stylers': {
            'color': '#445195',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'all',
        'elementType': 'labels.text.stroke',
        'stylers': {
            'color': '#141831'
        }
    },
    {
        'featureType': 'all',
        'elementType': 'labels.text.fill',
        'stylers': {
            'color': '#5564b2'
        }
    },
    {
        'featureType': 'poi',
        'elementType': 'all',
        'stylers': {
            'color': '#141831',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'subway',
        'elementType': 'all',
        'stylers': {
            'visibility': 'off'
        }
    },
    {
        'featureType': 'arterial',
        'elementType': 'geometry.stroke',
        'stylers': {
            'color': '#181e3e'
        }
    },
    {
        'featureType': 'highway',
        'elementType': 'geometry',
        'stylers': {
            'color': '#324160',
            'weight': '0.9'
        }
    },
    {
        'featureType': 'highway',
        'elementType': 'labels',
        'stylers': {
            'color': '#172137',
            'visibility': 'off'
        }
    },
    {
        'featureType': 'label',
        'elementType': 'labels',
        'stylers': {
            'visibility': 'off'
        }
    },
    {
        'featureType': 'administrative',
        'elementType': 'geometry',
        'stylers': {}
    }
];